// Chamados: nomes e tipos usados nas telas.
export const NOME_ORIGEM: Record<string, string> = {
  telefone: 'Telefone', whatsapp: 'WhatsApp', email: 'E-mail', portal: 'Portal', monitoramento: 'Monitoramento', interno: 'Interno',
};
export const NOME_STATUS_CHAMADO: Record<string, string> = {
  novo: 'Novo', triado: 'Triado', em_atendimento: 'Em atendimento', resolvido: 'Resolvido', descartado: 'Descartado',
};

export interface ChamadoItem {
  id: string; numero: string; status: string; origem: string; prioridade: string; descricao: string;
  criado_em: string; atualizado_em: string; versao: number;
  cliente_id: string | null; cliente: string | null; local_id: string | null; local: string | null;
  solicitante_nome: string | null; solicitante_telefone: string | null; contato_id: string | null; contato: string | null;
  os_total: number; os_abertas: number;
}

/** "há 3 h", "há 2 dias" — idade do pedido é o que o despacho olha primeiro */
export function idade(iso: string): string {
  const min = Math.max(0, Math.round((Date.now() - Date.parse(iso)) / 60_000));
  if (min < 60) return `há ${min} min`;
  const h = Math.round(min / 60);
  if (h < 48) return `há ${h} h`;
  return `há ${Math.round(h / 24)} dias`;
}
